import { render, staticRenderFns } from "./ViewScopingAssessmentOfTheRiskOfBias.vue?vue&type=template&id=f37f78d0&scoped=true"
import script from "./ViewScopingAssessmentOfTheRiskOfBias.vue?vue&type=script&lang=js"
export * from "./ViewScopingAssessmentOfTheRiskOfBias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37f78d0",
  null
  
)

export default component.exports